import { render } from "./verifyOTP.vue?vue&type=template&id=bb6187c2"
import script from "./verifyOTP.vue?vue&type=script&lang=js"
export * from "./verifyOTP.vue?vue&type=script&lang=js"

import "./verifyOTP.vue?vue&type=style&index=0&id=bb6187c2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__